import { ISurveyNote } from '../models';
import * as api from '../services/SurveyNotesAPI';
import { ActionTypes } from './ActionTypes';

export const SurveyNotesActionCreators = {
	GetSurveyNotes: (surveyId: number) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SURVEY_NOTES_GET_REQUESTED });

		return api
			.getSurveyNotes(surveyId)
			.then((notes: ISurveyNote[]) => dispatch({ type: ActionTypes.SURVEY_NOTES_GET_SUCCEEDED, payload: notes }));
	},
	SaveSurveyNote: (surveyNote: ISurveyNote) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SURVEY_NOTE_SAVE_REQUESTED });

		if (surveyNote.createdOn) {
			return api.updateSurveyNote(surveyNote).then(() => {
				return api
					.getSurveyNotes(surveyNote.surveyId)
					.then((notes: ISurveyNote[]) => dispatch({ type: ActionTypes.SURVEY_NOTE_SAVE_SUCCEEDED, payload: notes }));
			});
		} else {
			return api.addSurveyNote(surveyNote).then(() => {
				return api
					.getSurveyNotes(surveyNote.surveyId)
					.then((notes: ISurveyNote[]) => dispatch({ type: ActionTypes.SURVEY_NOTE_SAVE_SUCCEEDED, payload: notes }));
			});
		}
	},
	DeleteSurveyNote: (surveyNote: ISurveyNote) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SURVEY_NOTE_DELETE_REQUESTED });

		return api.deleteSurveyNote(surveyNote).then(() => {
			return api
				.getSurveyNotes(surveyNote.surveyId)
				.then((notes: ISurveyNote[]) => dispatch({ type: ActionTypes.SURVEY_NOTE_DELETE_SUCCEEDED, payload: notes }));
		});
	},
};
